import React from 'react';
import { Space } from 'antd';
import type { ReactNode } from 'react';
import { uxTokens } from '../design/ux';
import { usePageShell } from '../hooks/usePageShell';

export interface PageScaffoldProps {
  title?: string;
  subtitle?: string;
  actions?: ReactNode;
  filters?: ReactNode;
  hideChrome?: boolean;
  children: ReactNode;
}

/**
 * Registers list-report style chrome with the app shell and renders page body only.
 * Omit title to use the route label from nav config.
 */
const PageScaffold: React.FC<PageScaffoldProps> = ({
  title,
  subtitle,
  actions,
  filters,
  hideChrome,
  children,
}) => {
  usePageShell({
    ...(title !== undefined ? { title } : {}),
    ...(subtitle !== undefined ? { subtitle } : {}),
    ...(actions !== undefined ? { actions } : {}),
    ...(filters !== undefined ? { filters } : {}),
    ...(hideChrome !== undefined ? { hideChrome } : {}),
  });

  return (
    <Space direction="vertical" size={uxTokens.spacing.md} style={{ width: '100%' }}>
      {children}
    </Space>
  );
};

export default PageScaffold;
